export default __webpack_public_path__ + "static/media/chooseAlgorithmButton.85c59471.png";